export const stepList = [
  "add_entities",
  "business",
  "owner",
  "request",
  "overview"
];

export const eslintDefaulExport = false;
